import React, { useRef } from "react";
import { CgImage } from "react-icons/cg";
import { MdUpload, MdModeEdit, MdClose } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { IoIosAdd } from "react-icons/io";
import classes from "./UploadImageBoxNew.module.css";
import { imageUrl, mergeClass } from "../../../../resources/utils/helper";

const UploadImageBoxNew = ({
  disabled = false,
  state,
  setter,
  label,
  subLabel,
  edit = true,
  onDelete,
  onClose,
  fallBackImage,
  isCloseable,
  hideDeleteIcon = false,
  imgClass,
  uploadImageBox,
  containerClass = "",
  errorText,
  onEdit = () => {},
}) => {
  const inputRef = useRef(null);

  return (
    <>
      {label && (
        <label className={`${classes.label} ${subLabel && "m-0"}`}>
          {label}
        </label>
      )}
      {subLabel && <label className={classes.subLabel}>{subLabel}</label>}

      <div className={`${classes.box} ${containerClass}`}>
        <div className={mergeClass(classes.uploadImageBox, uploadImageBox)}>
          {/* Close Icon */}
          {isCloseable && (
            <span className={classes.closeIcon} onClick={onClose}>
              <MdClose />
            </span>
          )}
          {state?.name || typeof state == "string" ? (
            <div className={classes.imageUploaded}>
              <img
                src={
                  typeof state == "object"
                    ? URL.createObjectURL(state)
                    : imageUrl(state)
                }
                alt=""
                className={imgClass ? imgClass : ""}
              />
              <div className={classes.editAndDelete}>
                {edit && (
                  <>
                    {hideDeleteIcon && (
                      <div className={classes.icon} onClick={onDelete}>
                        <RiDeleteBinLine />
                      </div>
                    )}
                    <div
                      className={classes.icon}
                      onClick={() => {
                        inputRef.current.click();
                        onEdit();
                      }}
                    >
                      <MdModeEdit />
                    </div>
                  </>
                )}
              </div>
            </div>
          ) : (
            <div
              onClick={() => inputRef.current.click()}
              className={classes.uploadBox}
              style={disabled ? { cursor: "default" } : { cursor: "pointer" }}
            >
              {/* <CgImage className={classes.icon} /> */}
              <div
                className={
                  disabled ? classes.uploadIconDisabled : classes.uploadIcon
                }
              >
                {fallBackImage ? (
                  <div className={classes.imgDiv}>
                    <img src={fallBackImage} alt="fallBackImage" />
                  </div>
                ) : (
                  <IoIosAdd size={25} />
                )}
              </div>
            </div>
          )}
        </div>
        {/* Input For Image Upload */}
        <input
          disabled={disabled}
          hidden
          type={"file"}
          ref={inputRef}
          onChange={(e) => setter(e.target.files[0])}
        />
      </div>
      {
        errorText && 
        <div className="mt-2 text-danger">
          {errorText}
        </div>
    }
    </>
  );
};

export default UploadImageBoxNew;
